// @ts-nocheck

import { Locales } from '../../../../types/common';

import LogoDE from './gr_logo_DE.png';
import LogoEN from './gr_logo_EN.png';
import LogoES from './gr_logo_ES.png';
import LogoFR from './gr_logo_FR.png';

export { default as GRCollarCounterIcon } from './gr_collar_counter_icon.png';
export { default as GRVotesAgainstUserCounterIcon } from './gr_votes_against_user_counter_icon.png';
export { default as GRKnifeIcon } from './gr_knife_icon.png';
export { default as GRValidIcon } from './gr_valid_icon.png';
export { default as GRWrongIcon } from './gr_wrong_icon.png';
export { default as GRMainLogo } from './gr_main_logo.png';
export { default as GRLocker } from './gr_locker.png';
export { default as GRHoux } from './gr_houx.png';
export { default as GRPrimaryButtonBackroundImgPath } from './gr_primary_btn_bg.png';
export { default as GRRoundWonRibbonImgPath } from './gr_ribbon.png';
export { default as GRRoundWonTagImgPath } from './gr_won_round_tag_bg.png';

export const GRLogoFR = LogoFR;
export const GRLogoEN = LogoEN;
export const GRLogoDE = LogoDE;
export const GRLogoES = LogoES;

export const GiftRaceImgByLang = {
  [Locales.FR]: GRLogoFR,
  [Locales.EN]: GRLogoEN,
  [Locales.DE]: GRLogoDE,
  [Locales.ES]: GRLogoES,
};
